'use client'

import {
  Collapsible,
  CollapsibleContent,
  CollapsibleIcon,
  CollapsibleTrigger,
} from '@wartek-id/collapsible'
import { Icon } from '@wartek-id/icon'
import { ListItem } from '@wartek-id/list'
import {
  Sheet,
  SheetBody,
  SheetCloseButton,
  SheetContent,
  SheetOverlay,
  SheetTitle,
} from '@wartek-id/sheet'
import { Text } from '@wartek-id/text'

import { DataIndukFilterBentukPendidikanItem } from '@/apis/types'

export function FilterBentukSheet({
  bentuk,
  value,
  onSelect,
  show,
  onClose,
}: {
  value: string
  bentuk: DataIndukFilterBentukPendidikanItem[]
  show: boolean
  onClose: () => void
  onSelect: (newValue: string) => void
}) {
  return (
    <Sheet onClose={onClose} isOpen={show} sheetSize="xl">
      <SheetOverlay />
      <SheetContent>
        <SheetTitle bordered bold>
          Pilih Bentuk Pendidikan
        </SheetTitle>
        <SheetBody>
          <section className="p-4">
            <button
              className="flex w-full items-center justify-between gap-2 rounded border-b p-4 text-left font-semibold"
              data-testid="item-bentuk-all"
              onClick={() => {
                onSelect('')
                onClose()
              }}
            >
              <span>SEMUA BENTUK</span>
              {value === '' && <Icon color="informational">check</Icon>}
            </button>
            {bentuk.map((item) => (
              <Collapsible key={item.id} data-testid={`item-bentuk-${item.id}`}>
                <CollapsibleTrigger data-testid={`parent-bentuk-${item.id}`}>
                  <Text
                    variant="body-bold"
                    data-testid={`item-bentuk-${item.id}`}
                  >
                    {item.displayName}
                  </Text>{' '}
                  <CollapsibleIcon />
                </CollapsibleTrigger>
                <CollapsibleContent>
                  <div className="pl-2 pt-2">
                    {item.bentukPendidikan &&
                      item.bentukPendidikan.map((child) => (
                        <ListItem
                          key={child.id}
                          onClick={() => {
                            onSelect(child.id)
                            onClose()
                          }}
                          data-testid={`child-bentuk-${child.id}`}
                          selected={value === child.id}
                          iconRight={
                            value === child.id ? (
                              <Icon color="informational">check</Icon>
                            ) : null
                          }
                        >
                          {child.displayName}
                        </ListItem>
                      ))}
                  </div>
                </CollapsibleContent>
              </Collapsible>
            ))}
          </section>
        </SheetBody>
        <SheetCloseButton data-testid="btn-close-sheet" />
      </SheetContent>
    </Sheet>
  )
}
